<template>
	<div class="compare-gallery-view" @click="close()">
		<gallery-view class="gallery1" :images="images1"></gallery-view>
		<gallery-view class="gallery2" :images="images2" :flip="true"></gallery-view>
	</div>
</template>

<script>
	import GalleryView from './GalleryView';

	export default {
		props: {
			images1: {
				type: Array,
				default() {
					return [];
				}
			},
			images2: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		components: {
			GalleryView
		},
		methods: {
			close() {
				this.$store.commit('cmp_gallery_1', []);
				this.$store.commit('cmp_gallery_2', []);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.compare-gallery-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		& > .gallery1 {
			position: absolute;
			left: 0;
			top: 0;
			width: 50%;
			height: 100%;
		}

		& > .gallery2 {
			position: absolute;
			right: 0;
			top: 0;
			width: 50%;
			height: 100%;
			left: auto;
		}
	}
</style>